<template>
    <div id="searchUserInfo">
        <el-container>
            <el-header>
                <top-Nav></top-Nav>
            </el-header>
            <el-main>
                <el-row>
                    <div>
                        <div class="mainHead">
                            <div class="route">
                                <span class="crumbs"></span><span>用户管理</span><span class="arrow">></span><span>查看</span><span></span>
                            </div>
                            <div>
                                <!--<el-button type="primary" @click="getAddRoles()">保存</el-button>-->
                                <el-button type="primary" @click="returnBtn()">返回</el-button>
                            </div>
                        </div>
                    </div>
                  <div class="user_container">
                    <div class="mains clearfix">
                      <div class="mains_left">
                        <el-form :model="ruleForm" ref="ruleForm" label-width="132px" class="demo-ruleForm">
                          <el-form-item label="用户姓名:" prop="userName">
                            <el-input v-model="ruleForm.userName" :disabled="disabled"></el-input>
                          </el-form-item>
                          <el-form-item label="用户工号:" prop="userNumber">
                            <el-input v-model="ruleForm.userNumber" :disabled="disabled"></el-input>
                          </el-form-item>
                          <el-form-item label="用户账号:" prop="loginName">
                            <el-input v-model="ruleForm.loginName" :disabled="disabled"></el-input>
                          </el-form-item>
                          <el-form-item label="手机号:" prop="userPhone">
                            <el-input v-model="ruleForm.userPhone" :disabled="disabled"></el-input>
                          </el-form-item>
                          <el-form-item label="微信昵称:" prop="nickname">
                            <el-input v-model="ruleForm.nickname" class="wx_input" :disabled="disabled"></el-input>
                            <span class="unbind_wx" @click="unbindWx" v-if="isAuth('users:editUser')" :class="{disabled_class:isUnbindDisabled}">解绑</span>
                          </el-form-item>
                          <el-form-item label="启用状态:" prop="enabled">
                            <el-radio v-model="ruleForm.enabled" :label="false" :disabled="disabled">启用</el-radio>
                            <el-radio v-model="ruleForm.enabled" :label="true" :disabled="disabled">禁用</el-radio>
                          </el-form-item>
                        </el-form>
                      </div>
                      <div class="mains_right">
                        <div class="tab_tree">
                          <el-radio-group v-model="tabTree" style="margin-bottom: 20px;" @change="tabChange">
                            <el-radio-button label="first">功能权限</el-radio-button>
                            <el-radio-button label="second">数据权限</el-radio-button>
                          </el-radio-group>
                        </div>
                        <div v-show="firstShow" class="tree_container" :style="{height:basicHeight+'px'}">
                          <div v-if="isAuth('common:interface')">
                            <el-tree
                              :data="treeData"
                              ref="firstTree"
                              show-checkbox
                              node-key="id"
                              :default-expanded-keys="checkId"
                              :default-checked-keys="checkId"
                              :props="defaultProps"
                            >
                            </el-tree>
                          </div>
                        </div>
                        <div v-show="!firstShow" class="tree_container" :style="{height:basicHeight+'px'}">
                          <div v-if="isAuth('common:interface')">
                            <el-tree
                              :data="functionData"
                              show-checkbox
                              node-key="id"
                              ref="thirdTree"
                              :default-expanded-keys="treeListId"
                              :props="defaultProps1"
                            >
                            </el-tree>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </el-row>
            </el-main>
        </el-container>
    </div>
</template>
<script>
    import topNav from '../../components/TopNav.vue';
    import {ajaxFuncJson} from '@/api/ajax';
    export default {
        name: 'searchUserInfo',
        components: {
            topNav,
        },
        data() {
            return {
                msg: '编辑角色',
                tabTree:'first',
                tableW: '',
                tableW1: '',
                id:'',     //用户id
                editRoles: {
                    names: '',
                    remark: '',
                    enabled: '',
                    id: '', //角色id
                },
              treeData: [],
              defaultProps: {
                children:'list',
                label:'menuName',
                disabled:'enabled'
              },
              functionData:[],
              defaultProps1:{
                children:'children',
                label:'label',
                disabled:'enabled'
              },
              dialogVisible:false,
              firstShow:true,
              checkId:[],
                disabled:true,
                ruleForm: { //表单提交数据
                  userName:'',
                  userNumber:'',
                  loginName:'',
                  userPhone:'',
                  nickname:'',
                  enabled:'',
                },
              isUnbindDisabled:false,
              treeListId:[],    //数据权限选择id
              selectMenuId:'',
              basicHeight:'',
              windowResize:null,
            }
        },
        created(){
          this.id=this.$route.query.id;
          this.getEditUserInfo();
          this.getDataTree();
          this.getFunctionTree();
        },
        computed:{
            getMap() {
                return this.$store.state.buildingId
            },
        },
        watch: {
            getMap (newV, oldV) { // status的变化，然后执行操作
                
            },
        },
        mounted() {
            let that = this;
            that.windowResize= function () {
                that.tableW = ($('.el-row').width() - $('.mains_left').outerWidth(true) -1) * 0.25;
                that.tableW1 = ($('.el-row').width() - $('.mains_left').outerWidth(true) -1) * 0.5;
                that.basicHeight=$('body').height()-$('.mainHead')[0].offsetHeight-61-20-$('.tab_tree').outerHeight(true);
            };
            that.windowResize();
            window.addEventListener('resize',that.windowResize);
        },
        methods: {
          //tab切换
          tabChange(val){
            if(val==='first'){
              this.firstShow=true
            }else {
              this.firstShow=false
            }
          },
          getSetPermissionId(){
            let params={
              userId:this.id,
              menuId:this.selectMenuId,
            };
            ajaxFuncJson('/userMonitoring/findUserMonitor',params).then(res=>{
              if(res.data.status==200){
                this.dialogVisible=true;
                this.treeListId=[];
                if(res.data.data.length>0){
                  res.data.data.forEach((idList,index)=>{
                    this.treeListId.push(idList.monitoringId);
                  })
                }
                this.$nextTick(()=>{
                  this.$refs.thirdTree.setCheckedKeys(this.treeListId);
                });
              }else {
                this.$message({
                  message:res.data.msg,
                  type:'error'
                })
              }
            })
          },
          //筛选勾选的树形图
          filterNode(value, data) {
            if (!value) return true;
            return value.indexOf(data.id)!== -1;
          },
          //获取左侧用户的信息
          getEditUserInfo(){
            let params={
              id:this.$route.query.id,
            };
            ajaxFuncJson('/users/findUser',params).then(res=>{
              if(res.data.status==200){
                this.ruleForm.userName=res.data.data.user.userName;
                this.ruleForm.userNumber=res.data.data.user.userNumber;
                this.ruleForm.loginName=res.data.data.user.loginName;
                this.ruleForm.userPhone=res.data.data.user.userPhone;
                this.ruleForm.enabled=res.data.data.user.enabled;
                this.ruleForm.nickname=res.data.data.user.nickname;
                if(!this.ruleForm.nickname){
                  this.ruleForm.nickname='--';
                  this.isUnbindDisabled=true;
                }
              }else {
                this.$message({
                  message: res.data.msg,
                  type:'error'
                })
              }
            })
          },
          //解绑微信
          unbindWx(){
            if(!this.isUnbindDisabled){
              this.$confirm('是否确定解除当前账号与微信账号的绑定？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                closeOnClickModal:false,
                closeOnPressEscape:false,
              }).then(() => {
                let params={
                  id:this.id,
                  openType:2,
                };
                ajaxFuncJson('/users/editUser',params).then(res=>{
                  if(res.data.status==200){
                    this.$alert('解绑成功', '提示', {
                      confirmButtonText: '我知道了',
                      callback: action => {
                        this.getEditUserInfo();
                      }
                    });
                  }else {
                    this.$message({
                      message:res.data.msg,
                      type:'error',
                    })
                  }
                })
              }).catch(() => {

              });
            }
          },
          //获取权限的数据
          getDataTree(){
            let params={
              id:this.$route.query.id,
            };
            ajaxFuncJson('/menu/tree/list',params).then(res=>{
                if(res.data.status==200){
                  this.treeData=res.data.data.menuList;
                  this.checkId=res.data.data.permissions;
                }else {
                  this.$message({
                    message:res.data.msg,
                    type:'error',
                  })
                }
            });
          },
          //获取数据权限的数据
          getFunctionTree(){
            let params={
              id:this.$route.query.id,
            };
            ajaxFuncJson('/menu/getDateAuthorityTree',params).then(res=>{
              if(res.data.status==200){
                this.functionData=res.data.data;
                this.functionData.forEach((item,index)=>{
                  if(item.children.length>0&&item.children){
                    item.children.forEach((items,indexes)=>{
                      if(items.children.length>0&&items.children){
                        items.children.forEach((thirdItem,thirdIndex)=>{
                          if(String(thirdItem.label).indexOf('-')!=-1){
                            this.functionData[index].children[indexes].children[thirdIndex].label=String(thirdItem.label).replace('-','B');
                          }else if(String(thirdItem.label).indexOf('待标注')!=-1){
                            this.functionData[index].children[indexes].children[thirdIndex].label=thirdItem.label;
                          }else {
                            this.functionData[index].children[indexes].children[thirdIndex].label='L'+thirdItem.label;
                          }
                        })
                      }
                    })
                  }
                });
                this.getSetPermissionId();
              }else {
                this.$message({
                  message:res.data.msg,
                  type:'error'
                })
              }
            });
          },
            //返回按钮
            returnBtn(){
                this.$router.push({path:'/userManger'})
            },
        },
        destroyed(){
          let _this=this;
          window.removeEventListener("resize",_this.windowResize)
        },
    }
</script>
<style lang="scss" scope>
    @import "@/assets/css/mixin.scss";
    #searchUserInfo {
        height: 100%;
        .el-container {
            height: 100%;
            .el-main {
                width: 100% !important;
                margin:0;
                padding: 10px 20px 10px 20px;
                background: #f2f2f2;
                .el-row {
                  .mainHead{
                    margin-right: 0;
                  }
                }
            }
        }
      .mains{
        background: #fff;
        width: 100%;
      }
      .mains_left {
        float: left;
        margin: 20px 40px 0 0;
        width: 433px;
        .demo-ruleForm{
          .el-form-item{
            .el-input__inner{
              cursor: text;
            }
          }
        }
      }
      .mains_right {
        float: left;
        width: calc(100% - 473px);
        .el-table--small th, .el-table--small td {
          text-align: left;
        }
        .el-table--border th:first-child .cell, .el-table--border td:first-child .cell {
          padding-left: 20px;
        }
        .tab_tree{
          margin-top: 20px;
        }
        .el-radio-button__inner{
          border-left:1px solid #e0e0e0;
        }
        .el-radio-button__inner:hover{
          border: 1px solid #198cff;
        }
      }
      .tree_container{
        overflow: auto;

        .el-tree{
          .el-checkbox__input{
            z-index: 0;
          }
        }
      }
      .tree_container::-webkit-scrollbar {/*滚动条整体样式*/
        width: 4px;     /*高宽分别对应横竖滚动条的尺寸*/
        height: 1px;
      }
      .tree_container::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
        border-radius: 2px;
        -webkit-box-shadow: inset 0 0 1px rgba(0,0,0,0.2);
        background: #dddddd;
      }
      .tree_container::-webkit-scrollbar-track {/*滚动条里面轨道*/
        -webkit-box-shadow: inset 0 0 1px rgba(0,0,0,0.2);
        border-radius: 2px;
        background: #f5f5f5;
      }
      .tree_container1{
        max-height: 980px;
        overflow: auto;
        padding-bottom: 20px;
      }
      .unbind_wx{
        color: #198cff;
        padding-left: 18px;
        cursor: pointer;
      }
      .disabled_class{
        color: #C9C9C9;
        cursor: not-allowed;
      }
    }
</style>



// WEBPACK FOOTER //
// src/page/systemManger/searchUserInfo.vue